import { Link } from 'react-router-dom';

export default function Portfolio() {
  const companies = [
    {
      name: 'Diitect',
      tagline: 'Medical and safety technology for faster detection and response',
      description: 'Diitect develops intelligent fall detection and monitoring technology designed to support faster intervention, stronger risk mitigation, and better outcomes across care environments.',
      link: '/diitect',
      image: 'https://public.readdy.ai/ai/img_res/edited_25029807eb54d266f4dfd4ddf8895104_1ee6dd9b.jpg',
    },
    {
      name: 'Vetuvia',
      tagline: 'Veterinary health technology and commerce for modern care delivery',
      description: 'Vetuvia is building a platform that expands access to veterinary care while helping veterinarians create more flexible, scalable businesses. Its model combines care delivery, commerce, and technology designed to make virtual diagnosis more effective.',
      link: '/vetuvia',
      image: 'https://public.readdy.ai/ai/img_res/edited_444ca076ab64bb96a8f835cbc4ef3455_19281171.jpg',
    },
  ];

  return (
    <section id="portfolio" className="py-36 bg-white">
      <div className="max-w-[1280px] mx-auto px-8">
        {/* Section Header */}
        <div className="mb-24">
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
            <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
              Portfolio
            </p>
          </div>
          <h2 className="text-[44px] lg:text-[52px] font-light text-[#0A0F1E] leading-[1.15] tracking-[-0.02em]">
            Our <span className="font-semibold">companies</span>
          </h2>
          <p className="text-[17px] text-gray-600 leading-[1.8] font-light mt-6 max-w-[680px]">
            Each company in the Diivy portfolio is built around a meaningful problem, a clear market need, and long-term potential.
          </p>
        </div>

        {/* Company Cards */}
        <div className="space-y-20">
          {companies.map((company, index) => (
            <div
              key={index}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-12 pb-20 border-b border-gray-200 last:border-0"
            >
              {/* Image */}
              <div className="lg:col-span-5">
                <div className="w-full h-80 overflow-hidden">
                  <img
                    src={company.image}
                    alt={company.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="lg:col-span-7 flex flex-col justify-center space-y-8">
                <div className="space-y-4">
                  <h3 className="text-[36px] font-light text-[#0A0F1E] tracking-[-0.015em] leading-[1.2] group-hover:text-[#C9A96E] transition-colors duration-300">
                    {company.name}
                  </h3>
                  <p className="text-[15px] font-medium text-[#C9A96E] tracking-wide">
                    {company.tagline}
                  </p>
                </div>

                <p className="text-[16px] text-gray-600 leading-[1.85] font-light max-w-[560px]">
                  {company.description}
                </p>

                <Link
                  to={company.link}
                  className="inline-flex items-center gap-3 text-[13px] font-medium text-[#0A0F1E] hover:text-[#C9A96E] group/link transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  Visit {company.name}
                  <i className="ri-arrow-right-line text-base group-hover/link:translate-x-1.5 transition-transform duration-300"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Future Companies Note */}
        <div className="mt-20 pt-16 border-t border-gray-200">
          <p className="text-[15px] text-gray-500 leading-[1.8] font-light italic">
            More companies to come as Diivy continues building in high-impact categories.
          </p>
        </div>
      </div>
    </section>
  );
}